import {Dispatch} from 'redux';

import Types from '../Types';

import {sendDefaultCustomEvent} from '../../helpers/analytics';

import Character from '../../../domain/entities/Character';
import NameLabelColor from '../../../domain/value_objects/NameLabelColor';

import NetCharactersRepository from '../../../data/repositories/writer/NetCharactersRepository';

export interface Params {
  actorCharacterId?: number;
  actorCharacterFaceId?: number;
  name?: string;
  description?: string;
  state?: number;
  published?: boolean;
  rowOrderPosition?: number | null;
  ignoreUpdate?: boolean;
  nameLabelColor?: NameLabelColor | null;
  voiceActorName?: string | null;
}

export default function action(
  id: number,
  params: Params,
): (dispatch: Dispatch<any>) => Promise<Character> {
  return async (dispatch: Dispatch<any>): Promise<Character> => {
    try {
      const payload = await new NetCharactersRepository().update(id, {
        character: params,
      });
      if (!params.ignoreUpdate) {
        dispatch({payload, type: Types.UpdateCharacterSuccess});
      }
      sendDefaultCustomEvent({
        resourceType: 'character',
        resourceId: payload.id,
        resourceName: payload.name,
        actionName: 'update',
      });
      return payload;
    } catch (err) {
      dispatch({type: Types.UpdateCharacterFailure});
      throw err;
    }
  };
}
